import React from 'react';
import { Typography } from 'fronton-react';
import { LockSimpleIcon } from '@fronton/icons-react';
import { useTranslation } from 'react-i18next';
import { pickupOpt, pickupOptIconCntr, pickupOptTextContent } from './styles';
import { DeliveryMethodIcon } from '../../icons';

export const DATA_QA_PICKUP_OPTIONS_CONTAINER = 'pickup-options-container';

type DeliveryOptionProps = {
  isAvailable: boolean;
};

export const PickupOption: React.FC<DeliveryOptionProps> = ({ isAvailable }) => {
  const { t } = useTranslation();
  return (
    <div className={pickupOpt} data-qa={DATA_QA_PICKUP_OPTIONS_CONTAINER}>
      <div className={pickupOptIconCntr}>
        <DeliveryMethodIcon />
      </div>
      <div className={pickupOptTextContent}>
        <Typography variant="s" size="body_long" color={isAvailable ? 'text-primary' : 'text-minor'}>
          {`${t('product-info.stocks.in-stores.pickup')} ${
            isAvailable
              ? t('product-info.stocks.in-stores.today')
              : t('product-info.stocks.in-stores.not-available')
          }`}
        </Typography>
        {isAvailable ? (
          <Typography variant="s" size="body_long" color="text-primary">
            {t('product-info.stocks.in-stores.free')}
          </Typography>
        ) : (
          <LockSimpleIcon type="outline" size="l" color="text-minor" />
        )}
      </div>
    </div>
  );
};
